import MonitorIcon from '@mui/icons-material/Monitor';
import WordpressIcon from '../../components/SvgIcons/WordpressIcon';

export const genptTags = {
    unauthenticated: {
        title: "Unauth",
        bg_color: "var(--grey2)",
    },
    authenticated: {
        title: "Auth",
        bg_color: "var(--grey1)",
    },
    quick: {
        title: "Express",
        bg_color: "var(--grey1)",
    },
    normal: {
        title: "Site-wide",
        bg_color: "var(--grey1)",
    },
};

// genpt test status enum
export const genptTestStatus = {
    inprogress: {
        title: "In Progress",
        bg_color: "var(--functional-blue-600)",
    },
    completed: {
        title: "Completed",
        bg_color: "var(--secondary-700)",
    },
    failed: {
        title: "Failed",
        bg_color: "var(--functional-red)",
    },
};

export const genptFindingSeverity = {
    critical: {
        title: "Critical",
        color: "white",
        bg_color: "var(--functional-red-900)",
    },
    high: {
        title: "High",
        color: "white",
        bg_color: "var(--functional-red-700)",
    },
    medium: {
        title: "Medium",
        color: "white",
        bg_color: "var(--functional-orange)",
    },
    low: {
        title: "Low",
        color: "black",
        bg_color: "var(--functional-yellow)",
    },
    info: {
        title: "Informational",
        color: "black",
        bg_color: "var(--functional-blue-50)",
    },
};

export const genptFindingSeverityGraphColor = {
    critical: {
        title: "Critical",
        color: "var(--functional-red-900)",
    },
    high: {
        title: "High",
        color: "var(--functional-red-700)",
    },
    medium: {
        title: "Medium",
        color: "var(--functional-orange)",
    },
    low: {
        title: "Low",
        color: "var(--functional-yellow)",
    },
    info: {
        title: "Informational",
        color: "var(--functional-blue-50)",
    },
};


export const gentPTAssetTypeMap = {
    web_app: {
        title: "Web App",
        shortTitle: "Web",
        icon: (<MonitorIcon className={"text-primary-500 align-top"} />)
    },
    wordpress: {
        title: "WordPress",
        icon: <WordpressIcon />
    }
}

export const genptAssetToTemplateCountMap = {
    web_app: {
        unauthenticated: 4928,
    },
    wordpress: {
        unauthenticated: 10442,
        authenticated: 10584,
    }
}

export const findingStatusColors = {
    new: {
        name: "New",
        color: "var(--functional-red-900)",
        description: "Initial status of the newly discovered vulnerability."
    },
    existing: {
        name: "Existing",
        color: "var(--functional-red-700)",
        description: "Known issue under investigation or resolution."
    },
    reopened: {
        name: "Re-opened",
        color: "var(--functional-orange)",
        description: "Previously resolved issue that has reoccurred."
    },
    fixed: {
        name: "Fixed",
        color: "var(--success-green)",
        description: "Issue resolved with no further action required."
    },
}

export const testActivityMaps = {
    unauthenticated: {
        name: "Unauthenticated Testing",
        sub_activities: ["Verifying Core Integrity", "Assessing Plugin Review", "Evaluating Theme Safety"]
    },
    authenticated: {
        name: "Authenticated Testing",
        sub_activities: ["In-depth Core Examination", "Authenticated Plugin Checks", "Thorough Theme Inspection"]
    },
    exposures: {
        name: "Sensitive Data Exposure Checks",
    },
    miscellaneous: {
        name: "General Security Assessments",
    },
    misconfiguration: {
        name: "Configuration Integrity Review",
    },
    'default_logins': {
        name: "Authentication Security Evaluation ",
    },
    cves: {
        name: "Known Vulnerabilities Review",
    },
    'exposed_panels': {
        name: "Access Control Checks",
    },
    vulnerabilities: {
        name: "Targeted Threat Identification ",
    },
    fuzzing: {
        name: "Hidden Directories and Files Discovery",
    },
    crawling: {
        name: "Crawling",
    },
    crawling_additional_checks: {
        name: "Additional Checks",
    },
}

export const GPTTestConfigDefaults = {
    vulnerability: {
        rate_limit: 80,
        concurrency: 10,
        timeout: 30,
        retries: 2,
    },
    validation: {
        timeout: 30,
        retries: 2,
    },
};

